import * as types from '../constants/action-types';
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';
const INITIAL_STATE={
    searchTerm:"",
    
}

const searchReducer=(state=INITIAL_STATE,action)=>{
    
    switch(action.type){
      case types.SET_SEARCH_TERM:
         
          return {
              ...state,
              searchTerm:action.payload
          } 

     
       default :
       return state;
    }
}
const persistConfig = {
    keyPrefix: "molla-",
    key: "search",
    storage
}
export default persistReducer(persistConfig, searchReducer);